/**
 * Route CONTRACTS shared by the router and the tests.
 *
 * Why a module instead of inlining the string in `<Route path="…">`: a test
 * that re-types the pattern only proves the test agrees with itself. Here the
 * router and the test import the SAME literal, so reverting the route to
 * `/band/:bandSlug/stageplot-editor` (dropping the optional rider id that
 * `StagePlotEditorPage` consumes via `useParams`) breaks the suite.
 *
 * The rider id is OPTIONAL on purpose: the normal flow opens the editor with
 * `?edit=<id>`, and older bookmarks use the path form `/…/stageplot-editor/<id>`.
 * Both must keep working (audit 2026-10-07, F2).
 */
export const STAGEPLOT_EDITOR_ROUTE = '/band/:bandSlug/stageplot-editor/:riderId?';
